import { render, staticRenderFns } from "./widgetNavigation.vue?vue&type=template&id=e707b26a&scoped=true&"
import script from "./widgetNavigation.vue?vue&type=script&lang=js&"
export * from "./widgetNavigation.vue?vue&type=script&lang=js&"
import style0 from "./widgetNavigation.vue?vue&type=style&index=0&id=e707b26a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e707b26a",
  null
  
)

export default component.exports